import type { IconProps } from "./icon-types";

/** 표시 대상을 좁히는 필터를 나타내는 깔때기. 24 그리드 / stroke 기반 공용 glyph. */
export const FilterIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M3 4h18l-7 8v7l-4 2v-9Z" />
  </svg>
);
